import { useEditor, useNode } from '@craftjs/core';

import {
  EmailEditorSectionSetting,
  EmailEditorSigningOffSettings,
} from '../settings';
import EmailEditorContentElement from './EmailEditorContentElement';
import EmailEditorInlineText from './EmailEditorInlineText';
import EmailEditorSection from './EmailEditorSection';

import { useUserInfo } from 'hooks';
import { useGetUserProfileHeaderInfo } from 'pages/user-profile/components/overview/info/hooks';

const EmailEditorSigningOff = (props) => {
  const { id } = useNode();
  const { actions } = useEditor();

  const { text } = props;

  const { userId } = useUserInfo();

  const { data: userInfo } = useGetUserProfileHeaderInfo(userId);
  const fullName = `${userInfo?.firstName} ${userInfo?.lastName}`;

  const onChangeContent = (value) => {
    actions.history.throttle().setProp(id, (props) => (props.text = value));
  };

  return (
    <EmailEditorSectionSetting settings={<EmailEditorSigningOffSettings />}>
      <EmailEditorSection>
        <EmailEditorContentElement
          content={
            <EmailEditorInlineText
              content={text}
              onChangeContent={onChangeContent}
            />
          }
        />
        <EmailEditorContentElement content={fullName} editable={false} />
      </EmailEditorSection>
    </EmailEditorSectionSetting>
  );
};

EmailEditorSigningOff.craft = {
  displayName: 'Signing Off',
  props: {
    text: 'Regards,',
    settings: {
      bold: false,
      italic: false,
      underLine: false,
      fontSize: 14,
      color: '#333',
    },
  },
};

export default EmailEditorSigningOff;
